

























































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";

interface NkthJson {
  [key: string]: string;
}

@Component
export default class Calibration extends Vue {
  readonly kostlW = require("@/assets/odpt_list.json").weekday;
  readonly kostlH = require("@/assets/odpt_list.json").holiday;
  nkthW: NkthJson = require("@/assets/Shinjuku_w.json");
  nkthH: NkthJson = require("@/assets/Shinjuku_h.json");

  getTr(odpt: string, isWeekday: boolean) {
    const obj = isWeekday ? this.kostlW : this.kostlH;
    const key = odpt.slice(-4);
    if (key in obj) {
      return obj[key].tr;
    }
    return "-";
  }
}
